<div class="bg-(--color-secondary) rounded-2xl p-6 text-white">
  <div class="flex flex-col items-center gap-2">
    <div class="w-12 h-12 rounded-xl bg-(--color-main-20) flex items-center justify-center">
      <i class="fa-solid fa-check text-xl text-(--color-main)"></i>
    </div>

    <p class="text-center text-md text-white/80">تم إرسال رمز التحقق إلى</p>

    <p class="mt-1 text-lg font-semibold tracking-wider text-center text-white" dir="ltr">
      <span class="opacity-60">•••••••</span>
      <span class="ml-1">{{ (flow.phone() || '').slice(-2) }}</span>
    </p>
  </div>

  <form class="mt-5" [formGroup]="form" (ngSubmit)="confirm()">
   <div dir="ltr" class="relative w-full max-w-full px-0">
  <div class="relative grid grid-cols-6 gap-2 w-full max-w-105 mx-auto">
    @for (i of boxes; track i) {
      <div
        class="aspect-square min-w-0 flex items-center justify-center transition-all duration-200 border rounded-xl"
        [ngClass]="
          i === currentIndex
            ? 'border-(--color-main) text-white'
            : 'border-white/20 text-[--text-muted]'
        "
      >
        {{ form.value.otp?.[i] || '' }}
      </div>
    }

    <input
      #otpInput
      type="tel"
      formControlName="otp"
      maxlength="6"
      inputmode="numeric"
      pattern="[0-9]*"
      dir="ltr"
      autocomplete="one-time-code"
      class="absolute inset-0 z-10 w-full h-full opacity-[0.01] caret-transparent"
      (input)="onOtpInput()"
    />
  </div>
</div>

    @if (form.controls.otp.touched && form.controls.otp.invalid) {
      <div class="mt-3 text-sm text-center text-red-200">لازم تكتب 6 أرقام</div>
    }

    @if (flow.error()) {
      <div class="mt-3 text-sm text-center text-red-200">
        {{ flow.error() }}
      </div>
    }

    <div class="text-center">
      <button
        type="submit"
        [disabled]="form.invalid || flow.loading()"
        class="mt-4 rounded-lg bg-(--color-main) text-(--color-secondary) px-20 h-10 font-bold inline-flex items-center gap-2 cursor-pointer hover:bg-(--color-main-20) hover:text-(--color-main) transition-all duration-300 disabled:opacity-60 disabled:cursor-not-allowed"
      >
        <span>{{ flow.loading() ? 'جاري التأكيد...' : 'تأكيد' }}</span>
        <span class="text-xl">←</span>
      </button>
    </div>

    <button type="button" class="w-full mt-2 cursor-pointer text-md" (click)="flow.openStart()">
      تغيير رقم الهاتف
    </button>

    <button
      type="button"
      class="w-full mt-2 transition text-md"
      (click)="resendOtp()"
      [disabled]="!canResend || flow.loading()"
      [ngClass]="
        !canResend || flow.loading()
          ? 'text-white/40 cursor-not-allowed'
          : 'text-white/80 hover:text-white cursor-pointer'
      "
    >
      {{ canResend ? 'إعادة إرسال الرمز' : 'إعادة الإرسال خلال ' + resendCooldown + ' ثانية' }}
    </button>
  </form>
</div>
